// ModalAreaPix.jsx
import React, { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { api } from "../../api/api";
import { Alert } from "../../../util/Alertas";
import { QRCodeCanvas } from "qrcode.react";

const ModalAreaPix = forwardRef(function ModalAreaPix(props, ref) {
    const [show, setShow] = useState(false);
    const [currentId, setCurrentId] = useState(null);
    const [pix, setPix] = useState(null);
    const [timeLeft, setTimeLeft] = useState(null);

    useImperativeHandle(
        ref,
        () => ({
            openModal: (id) => {
                setCurrentId(id ?? null);
                api.get(`/api/Pedido/Pix/${id}`, (res) => {
                    setPix(res.data);
                    setShow(true);
                });
            },
            close: () => setShow(false),
            getId: () => currentId,
        }),
        [currentId]
    );

    const handleClose = () => setShow(false);

    // Função para calcular diferença em minutos/segundos
    const calcDiff = () => {
        if (!pix?.dtExpirateIn || !pix?.dtCreate) return null;

        const exp = new Date(pix.dtExpirateIn);
        const create = new Date(pix.dtCreate);
        const diffMs = exp - create;

        const diffSec = Math.floor(diffMs / 1000) % 60;
        const diffMin = Math.floor(diffMs / (1000 * 60)) % 60;
        const diffHour = Math.floor(diffMs / (1000 * 60 * 60)) % 24;
        const diffDay = Math.floor(diffMs / (1000 * 60 * 60 * 24));

        return `${diffDay}d ${diffHour}h ${diffMin}m ${diffSec}s`;
    };



    const getExpirateDate = () => {
        if (!pix?.dtExpirateIn) return null;
        const exp = new Date(pix.dtExpirateIn);

        // formato: DD/MM/YYYY HH:mm:ss
        return exp.toLocaleString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        });
    };

    // Copiar Pix para área de transferência
    const copyPix = () => {
        if (pix?.pixCopyPaste) {
            navigator.clipboard.writeText(pix.pixCopyPaste);
            Alert("Código Pix copiado!");
        }
    };

    useEffect(() => {
        // já calcula a primeira vez
        setTimeLeft(calcDiff());

        // cria intervalo que atualiza a cada 1s
        const interval = setInterval(() => {
            setTimeLeft(calcDiff());
        }, 1000);

        // limpa intervalo ao desmontar componente
        return () => clearInterval(interval);
    }, [pix]);

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Detalhes {currentId != null ? `#${currentId}` : ""}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {pix ? (
                    <>
                        <h5><strong>Expira em:</strong> {getExpirateDate()} ({timeLeft} restantes)</h5>
                        <div style={{ textAlign: "center", margin: "20px 0" }}>
                            <QRCodeCanvas
                                value={pix.pixCopyPaste}   // O código Pix
                                size={200}                 // Tamanho do QR
                                includeMargin={true}       // Adiciona margem
                            />
                        </div>
                        <Button variant="outline-primary" onClick={copyPix}>
                            Copiar código Pix
                        </Button>
                    </>
                ) : (
                    <p>O Pedido não possui Chave Pix vinculado...</p>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
});

export default ModalAreaPix;
